import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { images } from "../../helpers/images";
import { onClickWhiteLabelSignup } from "../../modules/actions/";
import { authUserData } from "../../helpers";
import Toast from "../../components/Toast";

class WhiteLabelSubdomain extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      disableButton: false,
      subdomain: "",
    };
  }

  componentDidMount() {}

  onChangeHandelUserInput = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;

    this.setState({
      [name]: value,
    });
  };

  onClickRedirectToSubdomain = () => {
    let redirectedURL = process.env.REACT_APP_WHITE_LABEL_HOST_URL.replace(
      "SUBDOMAIN",
      this.state.subdomain
    );
    const bypass = process.env.REACT_APP_SAQ_BYPASS_LOGIN === "true";
    this.setState({ disableButton: true });
    window.location.href = redirectedURL + (bypass ? "/dashboard" : "/login");
  };

  onTextKeyPress = (evt) => {
    if (evt.key === "Enter") {
      this.onClickRedirectToSubdomain(evt);
    }
  };

  render() {
    const { disableButton, subdomain } = this.state;

    return (
      <div className="grid-container full">
        <ToastContainer />

        <div className="grid-x  grid-margin-x" id="container">
          <div className="cell small-12 medium-5" id="infoplatesection">
            <div id="logosection">
              <img src={images.logo} />
            </div>

            <div id="infotxt">
              White label signup here
              <br />
              and create
            </div>

            <div id="infobutton">
              <Link to="/signup">
                <button className="button login" id="loginBtn">
                  Sign up
                </button>
              </Link>
              <p> or </p>{" "}
              <Link to="/white-label/subdomain">
                <button className="button login active" id="loginBtn">
                  Enter Subdomain
                </button>
              </Link>
            </div>
          </div>
          <div className="cell small-12 medium-7" id="formsection">
            <div id="registersaq" className="show">
              <h3 style={{ paddingTop: "320px" }}>Sign in</h3>
              <p>Sign in to your white label account.</p>
              <form>
                <div className="grid-container" id="formfieldscontainer">
                  <div className="grid-y grid-x">
                    <div className="small-12 medium-8 cell">
                      <label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter subdomain"
                          name="subdomain"
                          value={subdomain}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </label>
                    </div>
                  </div>
                  <div id="fieldbuttons">
                    {/* <button className="button nxt-btn">Create Account</button> */}
                    <button
                      className="button nxt-btn"
                      onClick={() => this.onClickRedirectToSubdomain()}
                      disabled={disableButton}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ onClickWhiteLabelSignup }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WhiteLabelSubdomain);
